import Text from '@front/web-ui/src/components/base-text/variants/text';
import Skeleton from '@front/web-ui/src/components/skeleton/skeleton';

type AccordionTitlePriceProps = {
  formattedPrice: string;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isLoadingPrices: boolean;
};

export const AccordionTitlePrice = ({
  formattedPrice,
  isITCSelectedOrSuccessfullyPaired,
  isLoadingPrices,
}: AccordionTitlePriceProps) =>
  isLoadingPrices ? (
    <Skeleton linesWidth={['70px']} />
  ) : (
    <Text strikedOut={isITCSelectedOrSuccessfullyPaired}>{formattedPrice}</Text>
  );
